import { Link } from 'react-router-dom';
import { useLocale } from '../../application/i18n/LocaleProvider';
import { BackIcon, ForwardIcon } from '../icons/ControlIcons';

/**
 * The deck, without the gesture (SPEC-025 D-10).
 *
 * A swipe is not a control: a keyboard cannot perform one and a screen reader
 * cannot describe one, so a deck reachable only by dragging is a deck two of the
 * four ways into this app cannot browse (NFR-04).
 *
 * Labelled with the plant each goes to rather than with "previous" and "next" —
 * the same argument SPEC-007 made against a text cue on its swipe. The direction
 * is the obvious part; WHICH PLANT is the information.
 *
 * Both are present on every card of a category of two or more, because the deck
 * is a ring (D-2 as revised): from the last card, "next" is the first one. They
 * are absent only in a category of one, where there is nowhere for either to go.
 */
export default function PlantDeckControls({ deck }) {
    const { t, localeCode } = useLocale();

    const control = (plant, messageKey, Glyph, place) => (plant ? (
        <Link
            className={`plant-deck__step plant-deck__step--${place}`}
            to={`/${localeCode}/plants/${plant.id}`}
            replace
            aria-label={t(messageKey, { plant: plant.prose?.commonName ?? plant.id })}
        >
            <Glyph size={22} />
        </Link>
    ) : null);

    return (
        <>
            {control(deck.previous, 'plants.detail.previousPlant', BackIcon, 'back')}
            {control(deck.next, 'plants.detail.nextPlant', ForwardIcon, 'forward')}
        </>
    );
}
